import React, {Component} from 'react';
import {Card, Col, Layout, Row} from "antd";
import {BreadcrumbProvider, withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {compose} from "redux";
import {connect} from "react-redux";
import LinkButton from "../Boilerplate/LinkButton";
import {Helmet} from "react-helmet";
import {GlobalHeader, PublicHeader} from "../Boilerplate/Menus";
import EmulateControl from "../Boilerplate/EmulateControl";
import * as R from "ramda";
import {PublicCompanyProfileDisplayFull} from "./CompanyProfileDisplayFull";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import ComponentNotFound from "../Boilerplate/ComponentNotFound";
import {withTransparentLoading} from "../Boilerplate/deferLoaderHoc";
import {getCompanyByShortName} from "../../actions/companies";
import {addressString} from "../AddressLink";
import {codeTables} from "../../codes";
import {trimEnd} from "lodash";

class CompanyProfilePublic extends Component {
  state = ({ profileWidth: undefined });

  updateDimensions = () => {
    const node = document.querySelector('#company-profile-display');
    this.setState({ profileWidth: node && node.scrollWidth });
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.updateDimensions();
    return window.addEventListener('resize', this.updateDimensions);
  };

  componentWillUnmount = () => window.removeEventListener('resize', this.updateDimensions);

  render() {
    const { auth, company, profile } = this.props;
    let company_description = '';
    let company_name = '';
    if (company) {
      company_name = company.resource.companyname.trim();
      const company_address = addressString({
        street: company.resource.address,
        suite: company.resource.address2,
        city: company.resource.city,
        state: company.resource.state,
        zip: company.resource.zip
      }, false);

      company_description = company_name;
      if (company.resource.companytype) {
        company_description += ' | ' + codeTables.get('companytype')
          .find(code => code.code === company.resource.companytype).name;
      }
      if (company_address) company_description += ` | ${company_address.trim()}`;
      company_description += '. Learn more about ' + trimEnd(company_name, '.') + '.';
    }
    return <React.Fragment>
      <BreadcrumbProvider>
        <div>
          <Helmet>
            <title>{company ? `${company_name} | cProject` : 'cProject'}</title>
            <meta name='description' content={company_description}/>
          </Helmet>
          <Layout>
            {auth ? <GlobalHeader/> : <PublicHeader/>}
            {auth && <EmulateControl/>}
            <Layout id='cproject-layout' className='layout-top' style={{ paddingTop: 146 }}>
              <Layout.Content id='content'>

                <Row type={'flex'} gutter={'12'}>
                  <Col className={'bid-dashboard-info'}
                       xs={24}
                       sm={{ span: 22, offset: 1 }}
                       md={{ span: 20, offset: 2 }}
                       lg={{ span: 18, offset: 3 }}
                       xl={{ span: 16, offset: 4 }}
                       xxl={{ span: 14, offset: 5 }}
                  >
                    <Card
                      id={'company-profile-display'}
                      className={'bid-dashboard-column-card'}
                      title={<h1>Company Profile</h1>}
                      extra={profile.companyadmin && company && profile.companyid === company.resource.id &&
                      <LinkButton icon={'edit'} to='/settings/company-profile/edit'>
                        <span style={{ display: this.state.profileWidth < 407 && 'none' }}>Edit</span>
                      </LinkButton>}
                    >
                      {(company && ((company.resource.profileprivacy === 0 && profile.companyid === company.resource.id)
                        || (company.resource.profileprivacy === 1 && auth) || company.resource.profileprivacy === 2)) ?
                        <PublicCompanyProfileDisplayFull {...this.props}/> : <ComponentNotFound resource='company'/>}
                    </Card>
                  </Col>
                </Row>

              </Layout.Content>
              <Layout.Footer id='footer'>
                cProject ©2019
              </Layout.Footer>
            </Layout>
          </Layout>
        </div>
      </BreadcrumbProvider>
    </React.Fragment>;
  }
}

const companyByUrl = createSelector(
  (state, props) => props.match.params.company,
  (state, props) => state.companies.indexes,
  (state, props) => state.companies.data,
  (companyName, companyIndexes, companies) => companies[companyIndexes[companyName.toLocaleLowerCase()]]
);

export default compose(
  withBreadcrumbCurried({ title: 'Company Profile', path: '/settings/company-profile' }),
  connect(
    (state, props) => ({
      profile: state.profile,
      company: companyByUrl(state, props),
      auth: R.path(['ui', 'authData'], state),
    }),
    (dispatch, props) => ({
      loader: () => dispatch(getCompanyByShortName(props.match.params.company))
    }),
  ),
  withTransparentLoading
)(CompanyProfilePublic);



// WEBPACK FOOTER //
// ./src/components/Settings/CompanyProfilePublic.js